import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const PricingCard = ({ plan, isPopular }) => {
  const cardVariants = {
    initial: { opacity: 0, scale: 0.9 },
    animate: { opacity: 1, scale: 1 },
    hover: { translateY: -10, boxShadow: "0 20px 40px rgba(251, 146, 60, 0.3)" },
  };

  const gradientClass = isPopular
    ? 'bg-gradient-to-br from-orange-500 to-amber-500'
    : 'bg-gradient-to-br from-orange-100 to-amber-100';

  const textGradientClass = isPopular
    ? 'text-white'
    : 'bg-clip-text text-transparent bg-gradient-to-r from-orange-600 to-amber-500';

  const buttonClass = isPopular
    ? 'bg-white text-orange-600 shadow-lg hover:shadow-xl hover:scale-[1.02]'
    : 'bg-gradient-to-r from-orange-500 to-amber-500 text-white shadow-lg hover:shadow-xl hover:scale-[1.02]';

  return (
    <motion.div
      className={`relative flex flex-col rounded-3xl p-8 border-2 overflow-hidden ${
        isPopular ? 'border-orange-500' : 'border-gray-200'
      }`}
      variants={cardVariants}
      initial="initial"
      animate="animate"
      whileHover="hover"
      transition={{ duration: 0.3 }}
      style={{
        background: isPopular
          ? 'linear-gradient(to bottom right, var(--tw-gradient-stops))'
          : 'linear-gradient(to bottom right, var(--tw-gradient-stops))',
        '--tw-gradient-stops': isPopular
          ? 'var(--tw-gradient-from) 0%, var(--tw-gradient-to) 100%'
          : 'var(--tw-gradient-from) 0%, var(--tw-gradient-to) 100%',
        '--tw-gradient-from': isPopular ? '#f97316' : '#fff7ed', // orange-500 / orange-50
        '--tw-gradient-to': isPopular ? '#fbbf24' : '#fff7ed',   // amber-500 / amber-50
      }}
    >
      {isPopular && (
        <span className="absolute -top-1 left-1/2 -translate-x-1/2 bg-orange-500 text-white text-xs font-bold px-4 py-1.5 rounded-full shadow-md uppercase tracking-wide z-10">
          Most Popular
        </span>
      )}
      <h3 className={`text-3xl font-bold mb-2 ${textGradientClass}`}>
        {plan.name}
      </h3>
      <p className={`mb-6 ${isPopular ? 'text-orange-100' : 'text-gray-500'}`}>
        {plan.description}
      </p>

      <div className="flex items-baseline mb-6">
        <span className={`text-5xl font-extrabold ${textGradientClass}`}>
          ${plan.price}
        </span>
        <span className={`text-xl font-medium ${isPopular ? 'text-orange-100' : 'text-gray-500'}`}>
          /month
        </span>
      </div>

      <ul className="space-y-4 flex-grow mb-8">
        {plan.features.map((feature, index) => (
          <li key={index} className={`flex items-center ${isPopular ? 'text-white' : 'text-gray-700'}`}>
            <CheckCircle2 className={`w-5 h-5 mr-3 flex-shrink-0 ${isPopular ? 'text-white' : 'text-orange-500'}`} />
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <motion.button
        className={`w-full py-4 rounded-xl font-bold text-lg transition-all duration-300 ${buttonClass}`}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
      >
        Choose {plan.name}
      </motion.button>
    </motion.div>
  );
};

export default PricingCard;